import React from "react";
import { useCurrentUser } from "hooks";
import styles from "./styles.module.scss";

const EstimateWarning = () => {
  const { currentUser, loading } = useCurrentUser();

  if (loading || currentUser) return null;

  return (
    <p className={styles.warning}>
      Prices shown are estimates. Sign up to see detailed costs for all
      listings.
    </p>
  );
};

export default EstimateWarning;
